import React from 'react';
import ChoiceField from '@/components/ui/ChoiceField';
import { assessmentTasks, PROGRESS_LABELS } from '@inclusivecore/shared';

export default function QuestionCard({ question, answer, answered = false, needsConfirmation = false, tasks, onTaskAnswer, disabled = false }) {
  const labels = assessmentTasks(question);
  const progress = tasks || labels.map(() => null);
  return <section id={`assessment-question-${question.id}`} className="space-y-3">
    <h3 id={`question-title-${question.id}`} className="font-semibold">Question {question.order}: {question.question_text}</h3>
    <p>Question status: {answered || needsConfirmation || tasks ? PROGRESS_LABELS[answer] : 'Not answered'}</p>
    {(answered || needsConfirmation) && !tasks && <p className="text-sm">Your saved question answer is retained. To update it, choose the progress of each task below.</p>}
    <div className="space-y-4">{labels.map((task, index) => <ChoiceField key={index} label={`Task ${index + 1}: ${task}`} value={progress[index] || ''} disabled={disabled} options={Object.entries(PROGRESS_LABELS)} onChange={value => onTaskAnswer(question.id, index, value)} help={`Current task status: ${PROGRESS_LABELS[progress[index]] || 'Not answered'}`} />)}</div>
  </section>;
}
